export default __webpack_public_path__ + "static/img3@2x-3cdc727e9984c9e92de858aab4cdc175.png";